const API_URL = process.env.REACT_APP_API_URL;

export const fetchNotifications = async (entityType, entityId, page = 1, limit = 20) => {
  const params = new URLSearchParams({ entityType, entityId, page, limit });
  const res = await fetch(`${API_URL}/api/notifications?${params}`);
  if (!res.ok) throw new Error('Failed to fetch notifications');
  return res.json();
};

export const refreshEmailStatus = async (notificationId) => {
  const res = await fetch(`${API_URL}/api/notifications/${notificationId}/refresh-email-status`, {
    method: 'POST',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to refresh status');
  }
  return res.json();
};

// Global notification list for the Notification Management page.
// `filters` may include: search, type, batchId, studentId, dateFrom, dateTo
export const fetchAllNotifications = async (filters = {}, page = 1, limit = 20) => {
  const params = new URLSearchParams({ page, limit });
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      params.append(key, value);
    }
  });
  const res = await fetch(`${API_URL}/api/notifications?${params}`);
  if (!res.ok) throw new Error('Failed to fetch notifications');
  return res.json();
};

export const resendNotification = async (notificationId) => {
  const res = await fetch(`${API_URL}/api/notifications/${notificationId}/resend`, {
    method: 'POST',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to resend notification');
  }
  return res.json();
};
